function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Pushes a callback onto the BioTRUST Trackers.js Data Layer
 * @param {(tracker: TrackersManager) => void} action
 */
export function trackersPush(action) {
  var _ref = window.bt || {},
      _ref$settings = _ref.settings;

  _ref$settings = _ref$settings === void 0 ? {} : _ref$settings;
  var _ref$settings$tracker = _ref$settings.trackersDataLayer,
      trackersDataLayer = _ref$settings$tracker === void 0 ? 'trackersJsDataLayer' : _ref$settings$tracker;
  window[trackersDataLayer].push(action);
}
/**
 * Pushes a custom event action onto the BioTRUST Trackers.js Data Layer
 * @param {string} eventName
 * @param {string} eventCategory
 * @param {string | undefined} [eventLabel]
 * @param {object} [eventProperties]
 */

export function pushCustomEvent(eventName, eventCategory, eventLabel) {
  var eventProperties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  trackersPush(function (trackers) {
    trackers.action('custom-event', eventName, eventCategory, _objectSpread({
      label: eventLabel
    }, eventProperties));
  });
}
/**
 * Triggers the 'AddToCart' event for tracking purposes.
 * @param {AjaxCartAdapter | StorefrontCartAdapter | BTCheckoutCartAdapter} adapter -
 * An instance of a class that extends CartAdapterBase. This is used to convert the cart data to a tracker usable model.
 */

export function trackAddToCartEvent(adapter) {
  trackersPush(function (trackers) {
    trackers.event('AddToCart', adapter.toAddToCartModel(), adapter.cart);
  });
}
/**
 * Triggers the 'BeginCheckout' (GA) AND 'InitiateCheckout' (Facebook) event for tracking purposes.
 * @param {AjaxCartAdapter | StorefrontCartAdapter | BTCheckoutCartAdapter} adapter -
 * An instance of a class that extends CartAdapterBase. This is used to convert the cart data to a tracker usable model.
 */

export function trackBeginCheckoutEvent(adapter) {
  trackersPush(function (trackers) {
    trackers.action('ec', '', 'checkout', adapter.toBeginCheckoutModel());
    trackers.action('initiate-checkout', adapter.toInitiateCheckoutModel());
  });
}
/**
 * Converts an object into an array of key-value pairs for use in Storefront API calls.
 * @param {object} inputObject - The input object with key-value pairs to convert.
 * @returns {Array<{key: string, value: string}>} An array of objects, each containing a `key` and `value` property.
 */

export function convertToKeyValueArray(inputObject) {
  return Object.entries(inputObject || {}).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    return {
      key: key,
      value: value
    };
  });
}